"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/OnCall/uiUtils.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Tooltip = require('web/components/Tooltip');











 const withTouchInterception = (Component) => {
  

  const WithTouchInterception = (props) => {
    // `this.props` for the stable ref callback and touch handlers (an
    // insertion effect runs before React attaches refs).
    const latestProps = _react.useRef.call(void 0, props)
    _react.useInsertionEffect.call(void 0, () => { latestProps.current = props })

    const elementRef = _react.useRef(null)
    const touchStartHandler = _react.useRef(null)
    const touchEndHandler = _react.useRef(null)

    // Stable, so it runs when the element mounts (and unmounts), not on every
    // render: the listeners are added once per element, as in the class.
    const setRef = _react.useCallback.call(void 0, (r) => {
      if (!r) return
      const { innerRef } = latestProps.current
      // SAFETY: only a callback ref is supported (HoverTooltip passes one); an
      // object ref throws, as in JS.
      const callbackRef = innerRef 
      if (callbackRef) callbackRef(r)
      elementRef.current = r

      const halt = e => {
        e.preventDefault()
        e.stopPropagation()
      }
      touchStartHandler.current = e => {
        const { onClick } = latestProps.current
        halt(e)
        if (onClick) onClick()
      }
      touchEndHandler.current = halt
      elementRef.current.addEventListener('touchstart', touchStartHandler.current)
      elementRef.current.addEventListener('touchend', touchEndHandler.current)
    }, [])

    // componentWillUnmount
    _react.useLayoutEffect.call(void 0, () => () => {
      if (!elementRef.current) return
      elementRef.current.removeEventListener('touchstart', touchStartHandler.current)
      elementRef.current.removeEventListener('touchend', touchEndHandler.current)
    }, [])

    return (
      _react2.default.createElement(Component, {
        ref: setRef,
        ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
      )
    )
  }

  // SAFETY: forwardRef types its props as PropsWithoutRef<P>; they are P (a
  // ref is never a prop here), which TypeScript cannot prove for a generic P.
  return _react2.default.forwardRef((props, ref) => (
    _react2.default.createElement(WithTouchInterception, { ...(props ), innerRef: ref, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}} )
  ))
}; exports.withTouchInterception = withTouchInterception

 const withOnCallTooltip = (
  place, hintText, className,
) => (Component) => _react2.default.forwardRef((props, ref) => (
  // SAFETY: as above, the props are P without a ref.
  _react2.default.createElement(_Tooltip.HoverTooltip, {
    place: place,
    type: "dark",
    content: _react2.default.createElement(_Tooltip.TooltipContent, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 81}},  hintText ),
    className: className, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}

    , _react2.default.createElement(Component, { ...(props ), ref: ref, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}} )
  )
)); exports.withOnCallTooltip = withOnCallTooltip

// The on-call panels stop these events (the overlay's touch and mouse-move
// handlers) from reaching the overlay. Listeners are bound on mount and removed
// on unmount with the events of that moment, like the classes'
// componentDidMount/componentWillUnmount. Pass the returned ref to the root.
 const useStopPropagation = (ignoredUIEvents) => {
  const rootRef = _react.useRef(null)
  const latestEvents = _react.useRef.call(void 0, ignoredUIEvents)
  _react.useInsertionEffect.call(void 0, () => { latestEvents.current = ignoredUIEvents })

  _react.useLayoutEffect.call(void 0, () => {
    const root = rootRef.current
    const events = latestEvents
    const stopPropagation = (e) => e.stopPropagation()
    events.current.forEach(e => root.addEventListener(e, stopPropagation))
    return () => events.current.forEach(e => root.removeEventListener(e, stopPropagation))
  }, [])

  return rootRef
}; exports.useStopPropagation = useStopPropagation
